import { AppDataTable, AppSearchBox, AppSectionTitle } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { createFileRoute } from '@tanstack/react-router'
import { useMemo } from 'react'
import { useSharableOpportunities } from '@/shared-hooks/useSharableOpportunities'
import { CustomSearch } from './-components/CustomSearch'
import { createPublicOpportunitiesColumns } from './-components/columns'
import { usePublicOpportunitiesPageState } from './-hooks/usePublicOpportunitiesPageState'

export const Route = createFileRoute('/_authenticated/opportunities/public/')({
  component: PublicOpportunitiesPage,
})

function PublicOpportunitiesPage() {
  // データフェッチング（全データ取得、is_releaseの値に関わらず取得）
  const { data, isLoading, error } = useSharableOpportunities({})

  // 状態管理とフィルタリング
  const { searchText, setSearchText, filteredOpportunities, handleCustomSearch, handleCustomSearchClear } =
    usePublicOpportunitiesPageState(data?.opportunities)

  // テーブルのカラム定義
  const columns = useMemo(() => createPublicOpportunitiesColumns(), [])

  return (
    <div className='grid h-full grid-rows-[auto_minmax(0,1fr)]'>
      <AppSectionTitle
        collapsible
        content={
          <div className='p-8 space-y-4'>
            {/* 検索バー */}
            <div className='flex flex-row gap-4 items-end'>
              <AppSearchBox
                label='公開オポチュニティを検索'
                tooltipContent='顧客課題、提案内容、背景、説明・詳細、きっかけ、情報源、サービス名、カテゴリ名、商談化した理由で検索できます'
                value={searchText}
                onChange={setSearchText}
                placeholder='顧客課題、提案内容、サービス名などで絞り込み'
              />
              <CustomSearch onSearch={handleCustomSearch} onClear={handleCustomSearchClear} />
            </div>
          </div>
        }
      >
        公開オポチュニティ一覧
      </AppSectionTitle>

      <AppDataTable
        data={filteredOpportunities}
        columns={columns}
        isLoading={isLoading}
        errorMessage={error ? `データの取得に失敗しました: ${error.message}` : undefined}
        pageSize={100}
        emptyMessage='公開オポチュニティがありません'
        defaultSortKey='updated_at'
        defaultSortDirection='desc'
        getRowKey={(row) => row.id}
        columnSelector={{ cookieKey: 'header-select-sharable-opportunities' }}
      />
    </div>
  )
}
